export default __webpack_public_path__ + "static/media/gallery_00.32b7fc70.jpg";